/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import { useDispatch, useSelector } from "react-redux";

import { IRootState } from "../../../state";
import { expressNotificationActions, IExpressNoticationListState } from "../../../state/express-notifications";
import { IExpressNotificationListItem } from "../../../state/express-notifications/express-notifications.reducer";
import { useEffect } from "react";
import { useModal } from "../../../context/ModalContext";
import { MODALS } from "../../../config/params";

export const useExpressNotificationsStore = () => {
  const dispatch = useDispatch();
  const { openModal } = useModal();
  const { expressNotificationsList } =
  useSelector((state: IRootState) => state.expressNotifications as IExpressNoticationListState);

  const setExpressNotificationList = (newNotifications: IExpressNotificationListItem[], append: boolean = false) => {
    !append ? dispatch(expressNotificationActions.setExpressNotificationList(
      newNotifications,
    )) :
      dispatch(expressNotificationActions.appendExpressNotificationList([
        ...expressNotificationsList,
        ...newNotifications,
      ]));
  };

  // removed temporarily to accomodate getAlerts api [delete if not used in future]
  // useEffect(()=>{
  //   if (expressNotificationsList.length) {
  //     openModal(MODALS.EXPRESS_SERVICE_UPSELL_MODAL);
  //   }
  // }, [expressNotificationsList]);

  return {
    setExpressNotificationList,
    expressNotificationsList,
  };
};
